export default __webpack_public_path__ + "static/media/Frame 108 (1).69db3ae2.svg";